import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-animated-modal";
import { PulseLoader } from 'halogenium';
import { kiplePaymentCodes } from '../../app/Common/Enum/KiplePaymentCode';

var portalRoot = null;

class TimePickerModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#confirm-modal').length == 0) {
            $('body').prepend('<div id="confirm-modal"></div>')
        }
        portalRoot = document.getElementById("confirm-modal");
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}
class TimePickerModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        }
    }
    isLoading(isLoading, callback) {
        if (!this.unmounted) {
            this.setState({isLoading}, () => {callback && callback()})
        }
    }
    componentWillUnmount = () => {
        this.unmounted = true;
        $(document).unbind('keypress', this.enterKeyListener)
        $(document).unbind('keyup',this.escListener);
    };
    componentDidMount = () => {
        // Set reference to that can be removed at componentWillUnmount
        this.enterKeyListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                this.props.onYes && this.props.onYes()
            }
        }
        this.escListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '27'){
                this.props.onNo && this.props.onNo()
            }
        }
        this.unmounted = false
        $(document).keypress(this.enterKeyListener);
        $(document).keyup(this.escListener);

    };
    onClose = () => {}

    // Parent to call this to dismiss the modal
    close() {
        this.props.onClose()
    }
    getBusinessIsClosedText = () => {
        return this.props.businessClosedText ? this.props.businessClosedText : (this.props.businessClosedText != null && lang.business_is_closed)
    }
    isBusinessClosed = () => {
        if (typeof this.props.isBusinessClosed !== undefined) {
            return this.props.isBusinessClosed
        }
        let currentTime = this.props.start || moment({hour: 8, minute: 0, second: 0, milisecond: 0})
        let closingTime = this.props.end || moment({hour: 18, minute: 0, second: 0, milisecond: 0})
        let realCurrentTime = moment()
        let x = null
        let y = null
        if (currentTime.length > 1) {
            x = currentTime.map( (currentTime, i) => {
                if(realCurrentTime.isBetween(currentTime, closingTime[i])) {
                    return closingTime[i].isBefore(currentTime)
                }
            })
            y = (yVal) => yVal === true
            if (x.find(y)) {
                return false
            }
        }
        else {
            return closingTime.isBefore(currentTime)
        }
    }
    getButtons = () => {
        let newTime = []
        let times = []
        let currentTime = this.props.start || moment({hour: 8, minute: 0, second: 0, milisecond: 0})
        let closingTime = this.props.end || moment({hour: 18, minute: 0, second: 0, milisecond: 0})
        let isAllowAsap = []
        let nowButton = null
        let arrayCurrentTime = []
        let checkArrayIndex = []

        if (currentTime && Array.isArray(currentTime)){
            currentTime.map( (newCurrentTime, i) => {
                if (newCurrentTime.isAfter(closingTime[i])) {
                    arrayCurrentTime[i] = true
                }
                else if (newCurrentTime && arrayCurrentTime[i] != true) {
                    checkArrayIndex.push(i)
                    newTime[i] = newCurrentTime.clone()
                    nowButton = 
                    <button onClick={() => this.props.onTimeSelected2(newTime[checkArrayIndex[0]])} className={"btn btn-default mb-2"}>
                    ASAP
                    </button>

                    do {
                        const time = newCurrentTime.clone()
                        times.push(<button onClick={() => this.props.onTimeSelected(time)} className={"btn btn-default mb-2"}>
                            {newCurrentTime.format('hh:mm a')}
                        </button>)
                        
                        newCurrentTime.add(15, 'minute')
                    } while(newCurrentTime.isBefore(closingTime[i], 'minute')) 

                    if (this.props.isDelivery && newCurrentTime.isBefore(moment({hour: OP_HOUR, minute: OP_MIN, second: 0, milisecond: 0}))) {
                        newCurrentTime = moment({hour: OP_HOUR, minute: OP_MIN, second: 0, milisecond: 0})
                        nowButton = null
                    }
                }
            } )
            this.props.realStart.map ( (start, i) => {
                isAllowAsap[i] = start.isBefore(moment())
            })

        } else {
            isAllowAsap = this.props.realStart
            nowButton = 
            <button onClick={() => this.props.onTimeSelected2(currentTime)} className={"btn btn-default mb-2"}>
            ASAP
            </button>

            do {
                const time = currentTime.clone()
                times.push(<button onClick={() => this.props.onTimeSelected(time)} className={"btn btn-default mb-2"}>
                    {currentTime.format('hh:mm a')}
                </button>)
                
                currentTime.add(15, 'minute')
            } while(currentTime.isBefore(closingTime, 'minute')) 

            if(this.props.isDelivery && currentTime.isBefore(moment({hour: OP_HOUR, minute: OP_MIN, second: 0, milisecond: 0}))){
                currentTime = moment({hour: OP_HOUR, minute: OP_MIN, second: 0, milisecond: 0})
                nowButton = null
            }
        }
        if (this.isBusinessClosed()) {
            // Null mean we "force" to NOT SHOW 'business_is_closed' text
            return <div>{this.getBusinessIsClosedText()}</div>
        }

        if(!this.props.isAllowAsap || !isAllowAsap || this.props.isPreOrderOnly){
            nowButton = null
        }
        if (times.length == 0) {
            return <div>{this.getBusinessIsClosedText()}</div>
        }
        return <div className="mt-3" style={{display:"grid", gridTemplateColumns: "auto auto auto", gridColumnGap: "8px", gridRowGap: "8px"}}>
            {
                nowButton
            }
            {
            times.map((timeButton, index) => {
                return <React.Fragment key={index}>
                    {timeButton}
                </React.Fragment>
            })
        }</div>
    }
    render() {
        return (
            <TimePickerModalPortal>
                <Modal
                    visible={true}
                    closemodal={this.props.onClose}
                    type="pulse">
                    <div className="menu-modal" style={{padding:"20px"}}>
                        <div>
                            {this.isBusinessClosed() ? "" : lang.please_select_your_time}
                        </div>
                        <div>
                            {this.props.merchantMenuHint}
                        </div>
                        { 
                            this.state.isLoading ? 
                            <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "center" }} /> :
                            this.getButtons()
                        }
                    </div>
                </Modal>
            </TimePickerModalPortal>
        )
    }
}
TimePickerModal.defaultProps = {
    customBody:null,
    message: "",
    buttonLayout: "default",
    isYesDestructive: false
}
export default TimePickerModal;